import React, {useEffect, useState} from 'react';
import {Anchor} from '@albert-io/atomic';

import {resource} from '@albert-io/json-api-framework/request/builder';
import MarkdownRendererV2 from 'generic/MarkdownRendererV2/MarkdownRendererV2.react';

interface CrumbProps {
  className?: string;
  id?: string;
  to: string;
}

export function Crumb(props) {
  return (
    <li className='reports_drilldown_nav__item u-display_flex u-align-items_center u-color_slate-600'>
      <Anchor inheritColor {...props} />
      <svg
        width='24'
        height='38'
        viewBox='0 0 6 38'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        className='u-pad-lr_1'
      >
        <path d='M0.999702 1L5.24503 19L0.999701 37' stroke='#E5E7EB' />
      </svg>
    </li>
  );
}

export function AssignmentCrumb({className, id, to}: CrumbProps) {
  const [assignmentName, setAssignmentName] = useState('');

  useEffect(() => {
    (async () => {
      const fetchedAssignment = await resource('assignments_v3')
        .mandarkEndpoint(['assignments_v3', id])
        .getResourcePromise();

      setAssignmentName(fetchedAssignment.getName());
    })();
  }, [id, setAssignmentName]);

  return (
    <Crumb className={className} to={to}>
      {assignmentName}
    </Crumb>
  );
}

export function QuestionCrumb({className, id, to}: CrumbProps) {
  const [questionTitle, setQuestionTitle] = useState('');

  useEffect(() => {
    (async () => {
      const fetchedQuestion = await resource('questions_v3')
        .mandarkEndpoint(['questions_v3', id])
        .getResourcePromise();

      setQuestionTitle(fetchedQuestion.getTitle());
    })();
  }, [id, setQuestionTitle]);

  return (
    <Crumb className={className} to={to}>
      <MarkdownRendererV2 text={questionTitle} />
    </Crumb>
  );
}

export function StandardCrumb({className, id, to}: CrumbProps) {
  const [standardTitle, setStandardTitle] = useState('');

  useEffect(() => {
    (async () => {
      const fetchedStandard = await resource('standards_v1')
        .mandarkEndpoint(['standards_v1', id])
        .getResourcePromise();

      setStandardTitle(fetchedStandard.getTitle());
    })();
  }, [id, setStandardTitle]);

  return (
    <Crumb className={className} to={to}>
      {standardTitle}
    </Crumb>
  );
}

export function StudentCrumb({className, id, to}: CrumbProps) {
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');

  useEffect(() => {
    (async () => {
      const fetchedStudent = await resource('students_v2')
        .mandarkEndpoint(['students_v2', id])
        .getResourcePromise();

      setFirstName(fetchedStudent.getFirstName());
      setLastName(fetchedStudent.getLastName());
    })();
  }, [id, setFirstName, setLastName]);

  return <Crumb className={className} to={to}>{`${firstName} ${lastName}`}</Crumb>;
}

export default {
  assignments: AssignmentCrumb,
  questions: QuestionCrumb,
  standards: StandardCrumb,
  students: StudentCrumb
};
